import React, { useState } from 'react';
import { Cancel01Icon } from 'hugeicons-react';
import { getResourceIcon } from '../../../Data/IconData';
import { Resource } from '../../../types/resource';
import '../../../Styles/Layout/Items/ResourceItem.css';
import '../../../Styles/Layout/ResourcePreview.css';

interface ResourceItemProps {
  resource: Resource;
  onClick?: (resource: Resource) => void;
  onDelete?: () => void;
  onMouseEnter?: () => void;
}

const TITLE_MAX_LENGTH = 22;

const truncate = (value: string, max: number) =>
  value.length > max ? `${value.substring(0, max - 3)}...` : value;

export const ResourceItem: React.FC<ResourceItemProps> = ({
  resource,
  onClick,
  onMouseEnter,
  onDelete,
}) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const getIcon = () => {
    if (resource.type === 'image' && resource.url) {
      return (
        <img
          src={resource.url}
          alt={resource.title}
          className="resource-item-image"
        />
      );
    }
    return getResourceIcon(resource.type);
  };

  const handleClick = () => onClick?.(resource);

  const handleDeleteClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (!onDelete) return;
    setIsRemoving(true);
    setTimeout(() => {
      onDelete();
    }, 400);
  };

  return (
    <div
      className={`resource-item-wrapper ${isRemoving ? 'removing' : ''}`}
      onMouseEnter={onMouseEnter}
    >
      <div
        className={`resource-item ${resource.type}`}
        onClick={handleClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        <div className="resource-item-icon-container">{getIcon()}</div>
        <span className="resource-item-name" title={resource.title}>
          {truncate(resource.title, TITLE_MAX_LENGTH)}
        </span>

        {onDelete && (
          <button
            type="button"
            className="resource-item-remove"
            onClick={handleDeleteClick}
            aria-label={`Remove ${resource.title}`}
          >
            <Cancel01Icon size={14} />
          </button>
        )}
      </div>
    </div>
  );
};
